import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/plugins/page.tsx");
